import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { Company } from "interfaces/company";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_COMPANY_DOCKS_" }
);

export interface PaginateCompanyDocksState extends IState {
  data: Company[] | Record<string, any>[];
}

const INITIAL_STATE: PaginateCompanyDocksState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateCompanyDocksState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginateCompanyDocksState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateCompanyDocksState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateCompanyDocks = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateCompanyDocksTypes = Types;
export const PaginateCompanyDocksActions = Creators;
